<div class="call-user-card">
  <!-- Header con título y botón de detalles -->
  <div class="card-header">
    <h3 class="card-title">Cliente</h3>
    <button class="user-details-btn" (click)="onViewUserDetails()" title="Ver detalles del usuario">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
          fill="#7F8694" />
        <path
          d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10 5C11.6569 5 13 6.34315 13 8C13 9.65685 11.6569 11 10 11C8.34315 11 7 9.65685 7 8C7 6.34315 8.34315 5 10 5ZM16 14.9C16 15.84 15.84 16 14.9 16H5.1C4.16 16 4 15.84 4 14.9C4 13.29 6.29 12 10 12C13.71 12 16 13.29 16 14.9Z"
          fill="#7F8694" />
      </svg>
    </button>
  </div>

  <!-- Campos de información del usuario -->
  <div class="user-fields">
    <div class="user-info-section">
      <div class="field-group">
        <!-- <div class="input-field">
          <label class="field-label">Nombre y Apellidos</label>
          <div class="input-container">
            <input type="text" class="field-input" [value]="getUserDisplayName()" placeholder="Nombre del usuario">
          </div>
        </div> -->

        <div class="input-field">
          <label class="field-label">Nº de teléfono</label>
          <div class="input-container">
            <input type="text" class="field-input" [value]="getUserPhone()"
              (input)="onPhoneChange($any($event.target).value)" placeholder="Número de teléfono">
          </div>
        </div>
      </div>
    </div>

    <!-- Alertas -->
    <div class="alerts-section" *ngIf="hasActiveService || isPriorityUser() || isSeniorUser()">
      <!-- Alerta de servicio activo -->
      <div class="alert-item service-alert" *ngIf="hasActiveService">
        <div class="alert-content">
          <div class="alert-info">
            <div class="alert-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="rgba(246, 86, 86, 0.2)" stroke="#F65656" />
                <path d="M12 8V12L14 14" stroke="#F65656" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <span class="alert-text">El usuario ya tiene un servicio creado</span>
          </div>
          <button class="view-details-btn" (click)="onViewServiceDetails()" title="Ver detalles del servicio">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="2.5" stroke="#7F8694" stroke-width="2" />
              <path
                d="M2.05 10C2.05 10 5.5 4.17 10 4.17C14.5 4.17 17.95 10 17.95 10C17.95 10 14.5 15.83 10 15.83C5.5 15.83 2.05 10 2.05 10Z"
                stroke="#7F8694" stroke-width="2" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Alerta de usuario senior -->
      <div class="alert-item senior-alert" *ngIf="isSeniorUser()">
        <div class="alert-content">
          <div class="alert-info">
            <div class="alert-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="rgba(246, 86, 86, 0.2)" stroke="#F65656" />
                <path d="M12 8V16M12 6H12.01" stroke="#F65656" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
            <span class="alert-text">Cliente con movilidad reducida, ayuda para subir y bajar</span>
          </div>
        </div>
      </div>

      <!-- Alerta de usuario prioritario -->
      <div class="alert-item priority-alert" *ngIf="isPriorityUser()">
        <div class="alert-content">
          <div class="alert-info">
            <div class="alert-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="rgba(246, 86, 86, 0.2)" stroke="#F65656" />
                <path d="M12 2L14.09 8.26L22 9L16 14.74L17.18 22.02L12 18.77L6.82 22.02L8 14.74L2 9L9.91 8.26L12 2Z"
                  fill="#F65656" />
              </svg>
            </div>
            <span class="alert-text">Usuario prioritario</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>